import { render, staticRenderFns } from "./ObjectGroupName.vue?vue&type=template&id=9a73b4fe&scoped=true&"
import script from "./ObjectGroupName.vue?vue&type=script&lang=js&"
export * from "./ObjectGroupName.vue?vue&type=script&lang=js&"
import style0 from "./ObjectGroupName.vue?vue&type=style&index=0&id=9a73b4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a73b4fe",
  null
  
)

export default component.exports